import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateFaqArticleRequest extends BaseUpdateRequest {
    title = '';
    body = '';
    faqCategoryId = '';
}